import { type ComponentProps, useCallback } from "react";
import { DocumentView } from "../pathologist-review/DocumentView";

interface Props {
  id: string;
  documentProps: ComponentProps<typeof DocumentView>;
  onSettled: (id: string, count: number) => void;
  onPending: (id: string) => void;
}

export function ReportCompositionSection({
  id,
  documentProps,
  onSettled,
  onPending,
}: Props) {
  const handleSettled = useCallback(
    (count: number) => onSettled(id, count),
    [id, onSettled]
  );
  const handlePending = useCallback(() => onPending(id), [id, onPending]);
  return (
    <DocumentView
      {...documentProps}
      onPaginationSettled={handleSettled}
      onPaginationPending={handlePending}
    />
  );
}
